import { useContext } from 'react'
import SuccessMessageContext from 'contexts/SuccessMessageContext'

export function useSuccessMessageState() {
    const successMessageState = useContext(SuccessMessageContext)
    return successMessageState 
}

export default useSuccessMessageState;